import { BaseService } from 'hungry-core2'
import actions from '@actions'

export default class CalcChefProcFeeModal extends BaseService {
  displayCalcChefProcFeeModal = ({ show }) => {
    this.dispatch(actions.displayCalcChefProcFeeModal({ show }))
  }
}
